module.exports = __webpack_public_path__ + "static/img/01.20c1798e.jpg";